import React, {useEffect, useState} from 'react';
import TitleValue from "components/textValue/TitleValue";
import Space from "../../../components/space/Space";
import messages from "res/messages/farsi";
import {REWARD_TYPES} from "./Rewards";
import IconTitleValue from "../../../components/textValue/IconTitleValue";
import moment from 'jalali-moment';
import copy from "copy-to-clipboard";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";

import ICCalender from "res/images/calendar_white.png";
import ICCopy from "res/images/copy.png";

export default function RewardItem(props) {

    const [reward, setReward] = useState()
    const [backgroundImage, setBackgroundImage] = useState("")

    useEffect(() => {
        setBackgroundImage(props.reward.background_image)
        setReward(props.reward)
    }, [props])

    return (<>
        {reward &&
        <div className="card marginTopSmall fullWidth"
             style={{backgroundImage: 'url(' + backgroundImage + ')', backgroundRepeat: "no-repeat"}}>
            <Space height={"1em"}/>
            <div className="horizontalScreen">
                <div className="fullWidth">
                    <TitleValue
                        title={reward.name}
                        titleClassName="mediumTextBold marginSmall"/>
                </div>
                <div className="card_blue_right_curve toLeft"
                     onClick={() => {
                         copy(reward.code)
                         props.onAlert(parseInt(reward.type) === REWARD_TYPES.DISCOUNT ?
                             messages.discountCodeCopied : messages.sarfeBonCopied, ALERT_TYPES.SUCCESS)
                     }}>
                    <IconTitleValue
                        flip={true}
                        title={reward.code}
                        titleClassName={"whiteColor mediumTextBold"}
                        icon={<img className="whiteColor xxSmallIcon marginTopXSmall" alt={"صرفه مارکت"} src={ICCopy}/>}/>
                </div>
            </div>
            <Space height={"1em"}/>
            {parseInt(reward.type) === REWARD_TYPES.DISCOUNT ?
                <TitleValue
                    title={reward.discount_type === "0" ? messages.fee : messages.value}
                    titleClassName="mediumText"
                    value={reward.discount_type === "0" ? parseInt(reward.price).toLocaleString() + messages.priceUnit :
                        parseInt(reward.price) + messages.percentUnit}
                    valueClassName="mediumTextBold"/> :
                <div>
                    <TitleValue
                        title={messages.initPrice}
                        titleClassName="mediumText"
                        value={parseInt(reward.price).toLocaleString() + messages.priceUnit}
                        valueClassName="mediumTextBold"/>
                    <Space height={"0.25em"}/>
                    <TitleValue
                        title={messages.remainingPrice}
                        titleClassName="mediumText greenColor"
                        value={(parseInt(reward.price) - parseInt(reward.used_price)).toLocaleString() + messages.priceUnit}
                        valueClassName="mediumTextBold greenColor"/>
                </div>
            }
            <div style={{display: "flex"}}>
                {reward.min_price && parseInt(reward.min_price) > 0 &&
                <TitleValue
                    title={messages.minValue}
                    titleClassName="mediumText"
                    value={parseInt(reward.min_price).toLocaleString() + messages.priceUnit}
                    valueClassName="mediumTextBold"/>
                }
                {reward.max_price && parseInt(reward.max_price) > 0 &&
                <TitleValue
                    title={messages.maxValue}
                    titleClassName="mediumText"
                    value={parseInt(reward.max_price).toLocaleString() + messages.priceUnit}
                    valueClassName="mediumTextBold"/>
                }
            </div>
            <Space height={"1em"}/>
            <div className="card_pink_left_curve halfWidth">
                <IconTitleValue
                    title={messages.expireDate}
                    titleClassName={"whiteColor mediumText"}
                    value={moment(reward.date_end, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')}
                    valueClassName={"whiteColor mediumTextBold"}
                    icon={<img className="whiteColor xxSmallIcon marginTopXSmall" alt={"صرفه مارکت"} src={ICCalender}/>}/>
            </div>
            <Space height={"1em"}/>
        </div>
        }
    </>)

}